import React from "react";
import searchIcon from "../assets/images/search.svg";

const SearchEmptyStateComponent = ({
  selectedCategories,
  selectedFloor,
  isSearchView = true,
}) => {
  return (
    <div
      className={`flex flex-col justify-center items-center h-[calc(100vh-10rem)] md:max-h-[500px] w-[100%]`}
    >
      <div className="space-y-2 text-center px-14">
        <img src={searchIcon} alt="" className="w-[120px] h-[120px] mx-auto" />
        <p className="font-medium text-base text-[#444444]">No Result Found</p>
        <p className="text-[#858585] font-normal text-sm max-w-md">
          We couldn’t find anything matching your filters. Try broadening your
          selection to discover more options.
        </p>
      </div>
    </div>
  );
};

export default SearchEmptyStateComponent;
